import IconButton from '@/shared/components/IconButton/IconButton'
import { useTranslation } from 'react-i18next'
import styles from './FeedbackTile.module.scss'
import Rating from '@/shared/components/Rating/Rating'

interface FeedbackTileProps {
  foodAndDrinksRating?: number
  serviceRating?: number
  ambianceRating?: number
  date: string
  message?: string
  author?: string
}

function FeedbackTile(props: FeedbackTileProps) {
  const {
    foodAndDrinksRating,
    serviceRating,
    ambianceRating,
    date,
    message,
    author = 'Anonymous'
  } = props
  const { t } = useTranslation()

  return (
    <div className={styles.feedbackTileWrapper}>
      <div className={styles.feedbackTileHeader}>
        <div className={styles.leftSideHeaderContainer}>
          <i className="la la-user-circle icon-large" />
          <div className={styles.authorInfo}>
            <p className={`${styles.authorLabel} body-bold-medium`}>{author}</p>
            <p className={`${styles.dateLabel} label-medium`}>{date}</p>
          </div>
        </div>
        <IconButton
          icon="las la-flag icon-big"
          onClick={() => null}
          color="primary"
        />
      </div>
      <div className={styles.feedbackTileRatings}>
        {foodAndDrinksRating && (
          <div className={styles.ratingItem}>
            <p className="label-large">{t('FEEDBACK.FOOD_AND_DRINKS')}</p>
            <Rating
              size="1.5rem"
              defaultValue={foodAndDrinksRating}
              isReadOnly
            />
          </div>
        )}
        {serviceRating && (
          <div className={styles.ratingItem}>
            <p className="label-large">{t('FEEDBACK.SERVICE')}</p>
            <Rating size="1.5rem" defaultValue={serviceRating} isReadOnly />
          </div>
        )}
        {ambianceRating && (
          <div className={styles.ratingItem}>
            <p className="label-large">{t('FEEDBACK.AMBIANCE')}</p>
            <Rating size="1.5rem" defaultValue={ambianceRating} isReadOnly />
          </div>
        )}
      </div>
      {message && (
        <div className={styles.feedbackTileMessage}>
          <p className="body-medium">{`"${message}"`}</p>
        </div>
      )}
    </div>
  )
}
export default FeedbackTile
